import { IntercomEvents } from '../enums/intercom-events';
import { shouldHideIntercom } from './user-details';

export const openChatSupport = () => {
  if (shouldHideIntercom()) {
    return;
  }
  
  if (window.Intercom) {
    window.Intercom(IntercomEvents.SHOW_MESSAGES);
  }
};

export const openIntercomHome = () => {
  if (shouldHideIntercom()) {
    return;
  }
  
  if (window.Intercom) {
    window.Intercom(IntercomEvents.SHOW);
  }
};
